'use client';

import { ExternalLink } from 'lucide-react';
import { SectionHeader } from '../shared';

interface OdooLinkSectionProps {
  odooId: number | null | undefined;
  model: string | null | undefined;
  name?: string | null;
}

export function OdooLinkSection({ odooId, model, name }: OdooLinkSectionProps) {
  if (!odooId || !model) {
    return null;
  }

  const ODOO_HOST = process.env.NEXT_PUBLIC_ODOO_URL || 'http://klyde.vivita-ai.com';
  const url = `${ODOO_HOST}/web#id=${odooId}&model=${model}&view_type=form`;

  return (
    <div>
      <SectionHeader title="OPEN IN ODOO" />
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 w-full p-2 rounded-lg border border-border hover:bg-accent transition-colors text-xs"
      >
        <ExternalLink className="h-3 w-3 text-muted-foreground shrink-0" />
        <span className="truncate">{name || 'View in Odoo'}</span>
      </a>
    </div>
  );
}
